/**
 * Hatim üye atama yardımcıları (saf): toplam/atanan/kalan miktar ve sayfa
 * aralığı çakışma kontrolleri. Aralık tipinde (Kuran/Cevşen) sayfa, diğer
 * tiplerde adet sayılır.
 */
import { isRangeType } from "./hatimType";
import { sumPages } from "./hatimEditing";

function memberEmail(u) {
  return String(u?.user?.email || u?.email || "").toLowerCase();
}

/** Bir üyenin atanmış miktarı (aralık tipinde sayfa toplamı). */
export function memberAssigned(u, type) {
  return isRangeType(type)
    ? sumPages(u?.assignedPageRanges)
    : Math.max(0, Number(u?.assignedAmount) || 0);
}

/** Tüm üyelerin atanmış toplamı. */
export function assignedTotal(users, type) {
  return (Array.isArray(users) ? users : []).reduce((s, u) => s + memberAssigned(u, type), 0);
}

/** Dağıtılmamış (kalan) miktar. totalAmount yoksa 0 döner. */
export function remainingToAssign(users, type, totalAmount) {
  const total = Math.max(0, Number(totalAmount) || 0);
  return Math.max(0, total - assignedTotal(users, type));
}

/**
 * Bir üyeye en fazla atanabilecek miktar: kalan + (düzenlemede) üyenin
 * mevcut ataması. totalAmount tanımsız/0 ise sınır yok (Infinity).
 */
export function maxAssignable(users, type, totalAmount, editingEmail) {
  const total = Math.max(0, Number(totalAmount) || 0);
  if (total <= 0) return Infinity;
  const me = editingEmail ? String(editingEmail).toLowerCase() : null;
  const own = me
    ? (users || []).filter((u) => memberEmail(u) === me).reduce((s, u) => s + memberAssigned(u, type), 0)
    : 0;
  return remainingToAssign(users, type, total) + own;
}

/** Diğer üyelere atanmış sayfa aralıkları (düzenlenen üye hariç). */
export function takenRanges(users, editingEmail) {
  const me = editingEmail ? String(editingEmail).toLowerCase() : null;
  const out = [];
  (Array.isArray(users) ? users : []).forEach((u) => {
    if (me && memberEmail(u) === me) return;
    (u?.assignedPageRanges || []).forEach((r) => {
      const s = Number(r?.startPage);
      const e = Number(r?.endPage);
      if (Number.isFinite(s) && Number.isFinite(e) && s <= e) out.push({ startPage: s, endPage: e });
    });
  });
  return out.sort((a, b) => a.startPage - b.startPage);
}

function overlaps(a, b) {
  return a.startPage <= b.endPage && b.startPage <= a.endPage;
}

/** Satırlar birbirleriyle ya da alınmış aralıklarla çakışıyor mu? */
export function hasRangeConflict(rows, taken) {
  const list = (Array.isArray(rows) ? rows : [])
    .map((r) => ({ startPage: Number(r?.startPage), endPage: Number(r?.endPage) }))
    .filter((r) => Number.isFinite(r.startPage) && Number.isFinite(r.endPage) && r.startPage <= r.endPage);
  for (let i = 0; i < list.length; i += 1) {
    for (let j = i + 1; j < list.length; j += 1) {
      if (overlaps(list[i], list[j])) return true;
    }
    for (const t of Array.isArray(taken) ? taken : []) {
      if (overlaps(list[i], t)) return true;
    }
  }
  return false;
}
